import logo from "assets/logo/logo-blue.svg";
import React from "react";
import FooterColumn from "components/utils/FooterColumn";
import { FooterColumnType } from "utils/types/util.types";
import pages from "utils/data/pages.json";
import CTA from "components/utils/CTA";
import { Link, useLocation } from "react-router-dom";
import { email, phone, products } from "utils/constants/constants";

const footerColumns: FooterColumnType[] = [
	{
		id: "contact",
		columnItems: [
			{
				id: "e-mail",
				text: email,
				link: `mailto:${email}`,
			},
			{
				id: "tel",
				text: phone,
				link: `tel:${phone}`,
			}
		]
	}, {
		id: "pages",
		columnItems: pages.map(({ id, link }) => ({ id, link })),
	}, {
		id: "products",
		columnItems: products.map(product => ({ id: product.textId, link: `/products/${ product.id }` })),
	}
]

function Footer() {

	const { pathname } = useLocation();

	return (
		<footer className="w-screen bg-footer bg-cover p-10 pt-60 md:pt-[325px] relative mt-60 lg:mt-[350px]">
			<CTA/>
			<div className="container container--mobile flex gap-10 items-start justify-start xs:justify-center">
				<Link to="/" className="hidden md:block">
					{
						pathname === "/" ?
							<div onClick={ () => window.scrollTo({ top: 0, left: 0, behavior: "smooth" }) }>
								<img src={ logo } alt="LARK-STRETCH" className="w-[200px]"/>
							</div> :
							<Link to="/">
								<img src={ logo } alt="LARK-STRETCH" className="w-[200px]"/>
							</Link>
					}
				</Link>
				<div className="flex gap-10 flex-col xs:flex-row">
					{
						footerColumns.map((footerColumn, index) =>
							<FooterColumn
								key={ index }
								column={ footerColumn }
							/>
						)
					}
				</div>
			</div>
		</footer>
	);
}

export default Footer;